import React, {useState} from 'react';
import './index.css';
import SkinDetections from './components/SkinDetections';
import SkinTypes from './components/SkinTypes';

export default function DetectionsContainer({
  isHd,
  isLandscape,
  isShowSkinType,
  isShowSkinHealth,
  transformedSequenceOfCategory,
  detectionMapping,
  activeDetection,
  setActiveDetection,
  scoreFormat,
  activeLang,
}) {
  const [showSkinTypeItems, setShowSkinTypeItems] = useState(true);

  const handleShowSkinTypeItemsClick = () => {
    setShowSkinTypeItems(prev => !prev);
  };

  return (
    <div className="skincaredetectionpreview-detections__container">
      {isShowSkinType && (
        <SkinTypes
          isLandscape={isLandscape}
          detectionMapping={detectionMapping}
          activeDetection={activeDetection}
          setActiveDetection={setActiveDetection}
          activeLang={activeLang}
          showSkinTypeItems={showSkinTypeItems}
          handleShowSkinTypeItemsClick={handleShowSkinTypeItemsClick}
        />
      )}
      <SkinDetections
        isHd={isHd}
        isLandscape={isLandscape}
        isShowSkinType={isShowSkinType}
        showSkinTypeItems={showSkinTypeItems}
        isShowSkinHealth={isShowSkinHealth}
        transformedSequenceOfCategory={transformedSequenceOfCategory}
        detectionMapping={detectionMapping}
        activeDetection={activeDetection}
        setActiveDetection={setActiveDetection}
        scoreFormat={scoreFormat}
        activeLang={activeLang}
      />
    </div>
  );
}
